import { StandardConfigurationConstructionTypeBase } from './base/standard-configuration-construction-type-base';

export class StandardConfigurationConstructionType extends StandardConfigurationConstructionTypeBase { }